import { CourseType, ModuleType, LessonType } from '../../../types'

// Takes in a course, list of modules and list of 
// lessons and returns a merged course object. 

// This is used by the courseHandler to combine any changes made to the
// modules and lessons separately into one course object. This allows it
// to continuously return an updated course object.

export const getFormattedCourse = (
  course: CourseType,
  modules: ModuleType[],
  lessons: LessonType[]
) => {
  for (const module of modules) {
    const moduleIndex = modules.indexOf(module)
    const matchingLessons = lessons.filter((lesson) => lesson.module === module._id)
    modules[moduleIndex].lessons = matchingLessons
  }

  return {
    ...course,
    modules
  }
}
